const taskTemplatesActionTypes = {
  SET_TASK_TEMPLATES: 'SET_TASK_TEMPLATES',
  UPDATE_TASK_TEMPLATE: 'UPDATE_TASK_TEMPLATE',
  ADD_TASK_TEMPLATE: 'ADD_TASK_TEMPLATE',
  DELETE_TASK_TEMPLATE: 'DELETE_TASK_TEMPLATE',
};
export default taskTemplatesActionTypes;
